export default __webpack_public_path__ + "static/media/no_matches_bg.2a9b70d6.svg";